import { ReactMarkdown } from "react-markdown/lib/react-markdown"

export default function Resolution({ brief, problem, need, solution, title }) {
  return (
    <section className="kf-resolution">
      <ReactMarkdown className="text-maingray text-2xl font-semibold">
        {title}
      </ReactMarkdown>
      <ReactMarkdown className="text-secgray ">
        {brief}
      </ReactMarkdown>
      <div>
        <div className="flex flex-col gap-x-2">
          <div className="flex gap-2 items-center">
            <img src="/assets/icons/exclamation-mark.svg"  alt="Exclamation mark pointing the problem" height="32" width="32"className="bg-maingray rounded-full p-2"/>
            <div className="body-text !text-maingray">Problem</div>
          </div>
          <div className="flex ml-1 h-full items-center">
          <div className="h-full ml-[0.6rem] bg-gradient-to-b from-maingray to-secgray">
          <ReactMarkdown className="ml-1 px-6 bg-[#f2f3f5] text-secgray prose-p:my-0">
            {problem}
          </ReactMarkdown>
          </div>
          </div>
          <div className="flex gap-2 items-center">
            <img src="/assets/icons/interrogation.svg"  alt="Interrogation mark pointing the need" height="32" width="32"className="bg-secgray rounded-full p-2"/>
            <div className="body-text !text-maingray">Need</div>
          </div>
          <div className="flex ml-1 h-full items-center">
          <div className="h-full ml-[0.6rem] bg-gradient-to-b from-secgray to-secondary">
          <ReactMarkdown className="ml-1 px-6 bg-[#f2f3f5] text-secgray prose-p:my-0">
            {need}
          </ReactMarkdown>
          </div>
          </div>
          <div className="flex gap-2 items-center">
            <img src="/assets/icons/checkmark.svg"  alt="Checkmark pointing the solution" height="32" width="32"className="bg-secondary rounded-full p-2"/>
            <div className="body-text !text-maingray">Solution</div>
          </div>
          <ReactMarkdown className="ml-4 px-6 text-secgray prose-p:my-0">
            {solution}
          </ReactMarkdown>
        </div>
      </div>
    </section>
  )
}